import { useState } from 'react';
import { KTSVG } from 'src/_metronic/helpers/components/KTSVG';
import { getBannerSize } from '../../utils/banner-size';
import ImageUploadModal from '../Modal';

type CoverImageType = {
  mobileDevice: boolean;
  coverImage: any;
  templateId: number;
};

export default function CoverImage(props: CoverImageType) {
  const { mobileDevice, coverImage, templateId } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [bannerResponse, setBannerResponse] = useState<any>([]);
  // Etiket yüklenecek görselin ölçüsüdür (max_width / ratio). Kutu yüksekliği sabit kalır: storefront kapağı da sabit yükseklikte kırparak gösteriyor.
  const coverSize = getBannerSize(coverImage?.ruleSet);
  return (
    <>
      <ImageUploadModal
        show={modalOpen}
        handleClose={() => setModalOpen(false)}
        maxSize={coverImage?.ruleSet?.max_size}
        allowTypes={coverImage?.ruleSet?.type}
        itemTypeId={coverImage?.id}
        templateId={templateId}
        sortIndex={0}
        setBannerResponse={setBannerResponse}
        maxWidth={coverImage?.ruleSet?.max_width}
      />
      <div
        onClick={() => setModalOpen(true)}
        className="d-flex w-100 border border-secondary bg-light align-items-center justify-content-center cursor-pointer"
        style={{ height: mobileDevice ? '120px' : '160px' }}
      >
        {bannerResponse?.[0]?.image ? (
          <img src={bannerResponse.length > 1 ? bannerResponse?.[1]?.image : bannerResponse?.[0]?.image} alt="banner" className="w-100 h-100 object-fit-cover" />
        ) : coverImage?.banners?.[0]?.image ? (
          <img src={coverImage?.banners?.[0]?.image} alt="banner" className="w-100 h-100 object-fit-cover" />
        ) : (
          <div className="d-flex flex-column gap-2 align-items-center">
            <KTSVG path="/media/icons/duotone/Files/Upload.svg" className="svg-icon-1 svg-icon-primary" />
            <span className="fw-bold text-muted fs-4">
              {coverSize ? `${coverSize.width} X ${coverSize.height}` : `${coverImage?.ruleSet?.max_width || '1216'} X ${mobileDevice ? '120' : '160'}`}
            </span>
            <span className="text-primary">Yükleme yapmak için dokunun.</span>
          </div>
        )}
      </div>
    </>
  );
}
